export const STORAGE_KEYS = {
  AUTH_SESSION: 'auth_session',
  SIDEBAR_COLLAPSED: 'sidebar_collapsed',
  AGENDAS_VIEW: 'agendas_view',
  CALENDAR_MOBILE_VIEW: 'calendar_mobile_view',
} as const;
